<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'sws_air_simulation' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">

      <div class="form-container">
        <div class="select-group">
          <ion-label class="select-label">{{'transport' | translate}}</ion-label>
          <ion-radio-group [value]="selectedOption" [(ngModel)]="selectedOption"
            (ionChange)="selectOption($event.detail.value)">

            <ion-item class="selection-item" button detail="false" lines="none">
              <ion-radio slot="start" value="airplane_with_pressure" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'airplane_with_pressure' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

            <ion-item class="selection-item" button detail="false" lines="none">
              <ion-radio slot="start" value="helicopter" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'helicopter' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

            <ion-item class="selection-item" button detail="false" lines="none">
              <ion-radio slot="start" value="lorry" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'lorry' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

            <ion-item class="selection-item" button detail="false" lines="none">
              <ion-radio slot="start" value="cable_car" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'cable_car' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>
          </ion-radio-group>
        </div>

        <div class="select-group" *ngIf="requiresHeightInput">
          <ion-label class="input-label">{{'max_height_diff_m' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" min="100" max="5100" [(ngModel)]="eMaxHeightDiff" name="eMaxHeightDiff"
            (ionInput)="onHeightChange()" (ionBlur)="onHeightChange()">
          </ion-input>
        </div>

        <ion-label class="option-label">
          <p *ngIf="this.selectedOption == 'helicopter' || this.selectedOption == 'cable_car'">
            {{'MAX_CLIMB_RATE_NOTE' |translate:{ value: this.selectedOption == 'helicopter'?5:3.2} }}
          </p>
        </ion-label>

      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>